import axios from 'axios';
import config from '@/config';
import store from './../index';

const NewsEndpoint = `${config.API_URL}/news`;

export const getNews = () =>
  new Promise((resolve, reject) =>
    axios
      .get(`${NewsEndpoint}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );
